"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CostumeType = void 0;
/**
 * Costume Type
 */
var CostumeType;
(function (CostumeType) {
    CostumeType["Standard"] = "Standard";
    CostumeType["EveningWear"] = "Evening Wear";
    CostumeType["PeriodWear"] = "Period Wear";
})(CostumeType || (exports.CostumeType = CostumeType = {}));
//# sourceMappingURL=costume-types.js.map